import { DateOptions, IConfiguredTrafficReport } from "./IConfiguredTrafficReport";
import { AggregationPeriod } from "@app/shared";
import { TotalVolumeDataLoader, downloadCSV } from "./TotalVolumeDataLoader";

export const TotalVolumeByFiveMinutes: IConfiguredTrafficReport = {
    name: "by 5 Minutes",
    key: "tv5m",
    description: "This report shows total traffic in 5min buckets for the given range",
    component: props => (<TotalVolumeDataLoader {...props} aggregationPeriod={AggregationPeriod.FiveMinutes} />),
    defaultChartType: 'line',
    defaultRange: DateOptions.LastWeek,
    downloadData:opts=> downloadCSV(AggregationPeriod.FiveMinutes, opts),
    config: {
        requiresMonth: false,
        allowsCustomRange: true,
        allowTargetTypeGrouping: true,
        requiresYear: false
    }
};